/* eslint-disable */
import React, { Component } from 'react';

import { Input } from 'antd';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import css from './Input.module.scss';

export default class CustomInput extends Component {
  static propTypes = {
    calendarIcon: PropTypes.any,
    className: PropTypes.string,
    dataqa: PropTypes.string,
    dark: PropTypes.any,
    deletable: PropTypes.bool,
    handleInputDelete: PropTypes.func,
    linkItem: PropTypes.bool,
    modificate: PropTypes.bool,
    noCursor: PropTypes.bool,
    onChange: PropTypes.func,
    onFocusDeleteInputConfirm: PropTypes.func,
    placeholder: PropTypes.string,
    showPassword: PropTypes.bool,
    isTopicAddModal: PropTypes.bool,
  };

  render() {
    const {
      className,
      dataqa,
      dark,
      modificate,
      calendarIcon,
      noCursor,
      onChange,
      linkItem,
      handleInputDelete,
      isTopicAddModal,
      ...rest
    } = this.props;
    if (linkItem) {
      const deleteButton =
        this.props.deletable && !isTopicAddModal ? (
          <CloseOutlined onClick={() => this.handleFileDelete(file.uuid)} />
        ) : null;
      return (
        <div className={css.block}>
          <Input
            {...rest}
            onChange={onChange}
            placeholder={this.props.placeholder}
            size={isTopicAddModal ? 'middle' : undefined}
            className={
              !isTopicAddModal &&
              classNames(className, css.Input, { [css.dark]: dark }, { [css.modificate]: modificate })
            }
            allowClear={isTopicAddModal ? true : undefined}
          />
          {deleteButton}
        </div>
      );
    }
    return (
      <div className={classNames({ [css.calendarIconBox]: calendarIcon })}>
        <Input
          {...rest}
          data-qa={dataqa}
          onChange={onChange}
          placeholder={this.props.placeholder}
          className={classNames(
            className,
            css.Input,
            { [css.dark]: dark },
            { [css.modificate]: modificate },
            { [css.showPassword]: this.props.showPassword },
            { [css.noCursor]: noCursor }
          )}
        />
        <div className={classNames({ [css.calendarIcon]: calendarIcon })}>{calendarIcon}</div>
      </div>
    );
  }
}
